// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.0005 1.75439L12.0002 11.6546L1 1.75439V21H3V14H5V21H7V14H17V21H19V14H21V21H23L23.0005 1.75439Z"}}]};

const Bridge6FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bridge-6-filled',
    ref,
    icon: element,
  },
));

Bridge6FilledIcon.displayName = 'Bridge6FilledIcon';

export default Bridge6FilledIcon;
